export enum MainRoutesEnum{
    AVALON_TEMPLATE = "avalon_template",

    HOME            = "HOME",
    KPI             = "KPI",
    PLANNING        = "PLANNING",
    TIME_SLOTS      = "TIME_SLOTS",
    VEHICLES        = "VEHICLES"
}
